<template>
  <div class="main-container">

    <FileUploadPopup v-show="showUploadPopup" @close="close" @existingQuestionnaire="existingQuestionnaire"/>
    <InternetAccessPopup v-show="showInternetConfirmation" @close="close" :fileContent="fileContent"/>
    <benchmarkDownload v-show="showBenchmarkConfirmation" @close="close" :fileContent="fileContent"/>

    <div class="navigation-button" :class="showUploadPopup || showInternetConfirmation ? 'active-blur' : ''">
      <button class="btn btn-outline-dark " type="submit" @click="showInternetConfirmation = true">
        {{ $t('new_questionnaire') }}
      </button>

      <button class="btn btn-outline-dark option" type="submit" @click="uploadType(false)">
        {{ $t('unfinished_questionnaire') }}
      </button>

      <button class="btn btn-outline-dark option " type="submit"  @click="uploadType(true)">
        {{ $t('result_upload') }}
      </button>
    </div>
  </div>

</template>
<script>
import FileUploadPopup from "@/components/Popups/FileUploadPopup";
import InternetAccessPopup from "./Popups/InternetAccessPopup";
import benchmarkDownload from "./Popups/benchmarkDownload";
export default {
  name: 'LandingPage',
  components: {
    FileUploadPopup,
    InternetAccessPopup,
    benchmarkDownload
  },
  data() {
    return {
      showUploadPopup: false,
      showInternetConfirmation: false,
      fileContent: '{}',
      results: false,
      showBenchmarkConfirmation: false,
    };
  },
  methods: {
    uploadType(isResults){
      this.results = isResults
      this.showUploadPopup = true
    },
    existingQuestionnaire(content){
      if(this.results){
        this.fileContent = content;
        this.showBenchmarkConfirmation = true;
      }else{
        this.fileContent = content;
        this.showInternetConfirmation = true;
      }
    },
    close() {
      this.showUploadPopup = false;
      this.showInternetConfirmation = false;
      this.showBenchmarkConfirmation = false;
    },
  }
}
</script>
<style scoped lang="scss">
.main-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10%;
  padding: 20% !important;
}

.btn {
  width: 100%;
}

.option{
  margin-top: 20px;
}

.navigation-button{
  width: 500px;
}
</style>
